$(function () {
  //获取要定位元素距离浏览器顶部的距离
  var navH = $('.custom_tabs_container').offset().top + 10;
  // console.log(navH);
  //滚动条事件
  $(window).scroll(function () {
    // console.log($(window).width())
    //获取滚动条的滑动距离
    var scroH = $(this).scrollTop() + 70;
    // console.log(scroH);
    //滚动条的滑动距离大于等于定位元素距离浏览器顶部的距离，就固定，反之就不固定
    if ($(window).width() < 767) {
      if (scroH >= navH) {
        $('.custom_tabs_container').css({ position: 'fixed' });
      } else if (scroH < navH) {
        $('.custom_tabs_container').css({ position: 'static' });
      }
    } else {
      if (scroH >= navH) {
        // $(".new-product-tab").css({
        //     "position": "fixed",
        //     "top": 69,
        //     "z-index": 2,
        //     "background-color": "#ECECEE"
        // });
        // $(".new-product-tab").addClass("new-fixed")
       
        $('.custom_tabs_container').css({ position: 'fixed' });
      } else if (scroH < navH) {
        $('body').removeClass('scroll-up');
         $('body').removeClass('scroll-down');
        $('.custom_tabs_container').removeClass('new-fixed');
        $('.custom_tabs_container').css({ position: 'static' });
      }
    }
  });

   // 遍历每个.tab，并给它们添加点击事件
  $(".custom_tabs_container .tab").each(function(index) {
    $(this).on("click", function() {
        console.log('index:',index)
    });
  });

});
